(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-tabs"] && !Shopify.designMode) return;
  try {
    
  /* Theme-editor only: keep the live site 100% JS-free.
     When a merchant selects a tab block, activate its tab so it's visible. */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-index]');
      const root = event.target.closest('.features-tabs');
      if (!panel || !root) return;

      const radios = root.querySelectorAll('.features-tabs__radio');
      const index = Number(panel.dataset.index);
      if (radios[index]) radios[index].checked = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-carousel')) {
    customElements.define(
      'reviews-carousel',
      class ReviewsCarousel extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;

          this.track = this.querySelector('[data-rv-track]');
          this.prev = this.querySelector('[data-rv-prev]');
          this.next = this.querySelector('[data-rv-next]');
          if (!this.track) return;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.onPrev = () => this.scrollByCards(-1);
          this.onNext = () => this.scrollByCards(1);
          this.update = this.update.bind(this);

          this.prev?.addEventListener('click', this.onPrev);
          this.next?.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);

          this.classList.add('is-ready');
          this.update();
        }

        disconnectedCallback() {
          this.prev?.removeEventListener('click', this.onPrev);
          this.next?.removeEventListener('click', this.onNext);
          this.track?.removeEventListener('scroll', this.update);
          window.removeEventListener('resize', this.update);
        }

        step() {
          const card = this.track.firstElementChild;
          if (!card) return this.track.clientWidth;
          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          return card.getBoundingClientRect().width + gap;
        }

        scrollByCards(direction) {
          this.track.scrollBy({
            left: this.step() * direction,
            behavior: this.reduceMotion ? 'auto' : 'smooth',
          });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;

          if (this.prev) this.prev.disabled = x <= 1;
          if (this.next) this.next.disabled = x >= max - 1;

          this.classList.toggle('reviews--no-nav', max <= 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-arrives"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('what-arrives-section')) {
    const VARIANT_EVENTS = ['variant:update', 'variantUpdate', 'variant-update', 'variant:change'];
    const POLL_MS = 400;

    customElements.define(
      'what-arrives-section',
      class WhatArrivesSection extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.designMode = !!(window.Shopify && window.Shopify.designMode);

          /* --- expand / collapse toggle --- */
          this.toggleButton = this.querySelector('[data-wa-toggle]');
          if (this.toggleButton) {
            this.handleClick = this.handleClick.bind(this);
            this.toggleButton.addEventListener('click', this.handleClick);
          }

          /* --- variant-reactive cards (only when a map was rendered) --- */
          this.mapNode = this.querySelector('[data-wa-map]');
          if (this.mapNode) this.initVariants();
        }

        disconnectedCallback() {
          this.toggleButton?.removeEventListener('click', this.handleClick);
          if (this.mapNode) {
            VARIANT_EVENTS.forEach((name) => document.removeEventListener(name, this.onVariantEvent));
            this.customWatcher?.disconnect();
            document.removeEventListener('change', this.onDocumentChange);
            window.removeEventListener('popstate', this.sync);
            window.clearInterval(this.pollId);
          }
        }

        handleClick() {
          const next = this.dataset.expanded !== 'true';
          this.dataset.expanded = String(next);
          this.toggleButton.setAttribute('aria-expanded', String(next));
        }

        /* --- variants --------------------------------------------------- */

        initVariants() {
          this.map = this.readMap();
          this.columnsMax = parseInt(this.dataset.columns, 10) || 3;
          this.lastVariantId = null;

          this.sync = this.sync.bind(this);
          this.onVariantEvent = this.onVariantEvent.bind(this);
          this.onDocumentChange = this.onDocumentChange.bind(this);

          // in initVariants()
          const qtyNode = this.querySelector('[data-wa-qty]');
          try {
            this.qtyMap = qtyNode ? JSON.parse(qtyNode.textContent) : {};
          } catch { this.qtyMap = {}; }

          /* Every device that any variant ships. Used for the off-catalogue
             size, where the mix is quoted per home rather than fixed. */
          this.hardwareDevices = new Set(
            Object.values(this.qtyMap).flatMap((counts) => Object.keys(counts || {}))
          );
          this.customMode = false;
          this.watchCustomSize();

          // The What arrives section is separate from the product form, so watch
          // for variant changes at the document level rather than in our subtree.
          VARIANT_EVENTS.forEach((name) => document.addEventListener(name, this.onVariantEvent));
          document.addEventListener('change', this.onDocumentChange);
          window.addEventListener('popstate', this.sync);
          this.pollId = window.setInterval(this.sync, POLL_MS);

          this.sync();
        }

        readMap() {
          try {
            return JSON.parse(this.mapNode.textContent);
          } catch (error) {
            console.warn('what-arrives: could not parse variant map', error);
            return {};
          }
        }

        cards() {
          return Array.from(this.querySelectorAll('[data-device]'));
        }

        onVariantEvent(event) {
          const detail = event.detail || {};
          const id =
            detail.resource?.id ??
            detail.variant?.id ??
            detail.data?.variantId ??
            detail.data?.resource?.id ??
            null;

          if (id) this.apply(String(id));
          else requestAnimationFrame(this.sync);
        }

        onDocumentChange(event) {
          if (!event.target.closest('form[action*="/cart/add"], variant-picker, .variant-picker')) return;
          requestAnimationFrame(this.sync);
        }

        currentVariantId() {
          const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input?.value) return String(input.value);

          const fromUrl = new URLSearchParams(window.location.search).get('variant');
          if (fromUrl) return String(fromUrl);

          return this.dataset.variantId || '';
        }

        sync() {
          const id = this.currentVariantId();
          if (id === this.lastVariantId) return;
          this.lastVariantId = id;
          this.apply(id);
        }

        apply(variantId) {
          const cards = this.cards();

          // Labels update in the editor too, so merchants see real counts.
          this.applyLabels(cards, variantId);

          if (this.designMode) {
            // Keep every card visible in the editor so they can all be edited.
            cards.forEach((card) => (card.hidden = false));
            this.updateColumns(cards);
            return;
          }

          const allDevices = cards.map((card) => card.dataset.device).filter(Boolean);
          const allowed = this.customMode ? allDevices : this.map[variantId] || allDevices;

          cards.forEach((card) => {
            const device = card.dataset.device;
            const target = card.closest('.shopify-block') || card;
            target.hidden = device ? !allowed.includes(device) : false;
          });

          this.updateColumns(cards);
        }

        /**
         * "Larger home" has no variant, so ?variant= keeps whatever was chosen
         * before it and the cards would go on showing that mix. The plan
         * selector marks the state on itself, so follow that attribute instead.
         */
        watchCustomSize() {
          const selector = document.querySelector('plan-selector-component');
          if (!selector) return;

          const read = () => {
            const next = selector.dataset.size === 'custom-size';
            if (next === this.customMode) return;
            this.customMode = next;
            this.lastVariantId = null;   // force apply() to redraw
            this.apply(this.currentVariantId());
          };

          this.customWatcher = new MutationObserver(read);
          this.customWatcher.observe(selector, { attributes: true, attributeFilter: ['data-size'] });
          read();
        }

        applyLabels(cards, variantId) {
          /* Off-catalogue: show the whole range and drop the counts, because the
             mix is assessed per home rather than fixed. The app card keeps its
             own label -- one account is one account at any size. */
          if (this.customMode) {
            cards.forEach((card) => {
              const labelEl = card.querySelector('[data-wa-label]');
              if (!labelEl) return;
              if (labelEl.dataset.defaultLabel == null) {
                labelEl.dataset.defaultLabel = labelEl.textContent.trim();
              }
              const isHardware = this.hardwareDevices.has(card.dataset.device);
              labelEl.hidden = isHardware;
              if (!isHardware) labelEl.textContent = labelEl.dataset.defaultLabel;
            });
            return;
          }

          cards.forEach((card) => {
            const labelEl = card.querySelector('[data-wa-label]');
            if (labelEl) labelEl.hidden = false;
          });
          this.applyCountLabels(cards, variantId);
        }

        applyCountLabels(cards, variantId) {
          const counts = this.qtyMap[variantId] || {};

          cards.forEach((card) => {
            const labelEl = card.querySelector('[data-wa-label]');
            if (!labelEl) return;

            // Remember the merchant's own label so we can restore it if a variant
            // has no count for this device (e.g. the app card's "1 account").
            if (labelEl.dataset.defaultLabel == null) {
              labelEl.dataset.defaultLabel = labelEl.textContent.trim();
            }

            const count = counts[card.dataset.device];
            labelEl.textContent = count != null ? `×${count}` : labelEl.dataset.defaultLabel;
          });
        }

        updateColumns(cards) {
          const visible = cards.filter(
            (card) => !(card.closest('.shopify-block') || card).hidden
          ).length;
          const cols = Math.max(1, Math.min(visible || this.columnsMax, this.columnsMax));
          this.style.setProperty('--wa-columns', String(cols));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
